/** Canonical in-app notification type identifiers */
export const NOTIFICATION_TYPES = {
  dailyEntryNotSubmitted: "daily_entry_not_submitted",
  correctionRequested: "correction_requested",
  payPeriodReadyForReview: "pay_period_ready_for_review",
  criticalExceptionCreated: "critical_exception_created",
  payPeriodApproved: "pay_period_approved",
  payPeriodLocked: "pay_period_locked",
  exportReady: "export_ready",
} as const;

export type NotificationType = (typeof NOTIFICATION_TYPES)[keyof typeof NOTIFICATION_TYPES];

export const NOTIFICATION_TYPE_LABELS: Record<NotificationType, string> = {
  daily_entry_not_submitted: "Daily entry missing",
  correction_requested: "Correction requested",
  pay_period_ready_for_review: "Pay period ready for review",
  critical_exception_created: "Critical exception",
  pay_period_approved: "Pay period approved",
  pay_period_locked: "Pay period locked",
  export_ready: "Export ready",
};
